<div id='td-wb-address-form'>
  @if (showTitleAndCallout()) {
    <div class="td-wb-address__heading"
         [translate]="usageId() === 'home' ?  'tdWb.address.NEW_HOME_ADDRESS' : 'tdWb.address.MAILING_ADDRESS'"></div>
  }
  @if (showTitleAndCallout()) {
    <div class="td-wb-address__callout">
      <td-wb-call-out>
        <span [innerHTML]="'tdWb.address.CALLOUT' | tdWbTranslate"></span>
      </td-wb-call-out>
    </div>
  }
  @if (usageId() === 'home') {
    <div class="td-wb-address__info"
         translate="tdWb.address.NOTE"></div>
  }
  <td-wb-form-row class="td-wb-address__form-row">

    <td-wb-input-group class="td-wb-address__form-input">
      <td-wb-input-group-label class="td-wb-address__label">
        <label [for]="'td-wb-address-street-num-' + usageId()"
               translate="tdWb.address.STREET_NUM"
               class="td-wb-address__label"></label>
      </td-wb-input-group-label>
      <td-wb-input-group-field class="td-wb-address__form-input-field">
        <input [attr.id]="'td-wb-address-street-num-' + usageId()"
               [(ngModel)]="streetNumDisplay"
               (ngModelChange)="onViewModelChange()"
               [name]="'streetNumber-' + usageId()"
               type="text"
               maxlength=20
               tdWbInput
               [required]="isRuralOrPoBoxEmpty()"
               [disabled]="isDisabled()"
               class="td-wb-address__form-input-field">
        <td-wb-input-errors errorKeyNamespace="tdWb.address.validationMsges.streetNum" />
      </td-wb-input-group-field>
    </td-wb-input-group>

    <td-wb-input-group class="td-wb-address__form-input">
      <td-wb-input-group-label class="td-wb-address__label">
        <label [for]="'td-wb-address-street-' + usageId()"
               translate="tdWb.address.STREET"
               class="td-wb-address__label"></label>
      </td-wb-input-group-label>
      <td-wb-input-group-field class="td-wb-address__form-input-field">
        <input [attr.id]="'td-wb-address-street-' + usageId()"
               [(ngModel)]="selectedAddress.streetName"
               (ngModelChange)="onViewModelChange()"
               [name]="'streetName-' + usageId()"
               tdWbInput
               [required]="isRuralOrPoBoxEmpty()"
               maxlength=30
               type="text"
               [disabled]="isDisabled()"
               class="td-wb-address__form-input-field">
        <td-wb-input-errors errorKeyNamespace="tdWb.address.validationMsges.streetName" />
      </td-wb-input-group-field>
    </td-wb-input-group>

    <td-wb-input-group class="td-wb-address__form-input-small">
      <td-wb-input-group-label class="td-wb-address__label">
        <label [for]="'td-wb-address-unit-' + usageId()"
               translate="tdWb.address.OPTIONAL"
               class="td-wb-address__label"></label>
      </td-wb-input-group-label>
      <td-wb-input-group-field class="td-wb-address__form-input-field">
        <input tdWbInput
               [attr.id]="'td-wb-address-unit-' + usageId()"
               [(ngModel)]="selectedAddress.unitNum"
               (ngModelChange)="onViewModelChange()"
               type="text"
               [name]="'unitNumber-' + usageId()"
               maxlength=6
               [disabled]="isDisabled()"
               class="td-wb-address__form-input-field">
      </td-wb-input-group-field>
    </td-wb-input-group>
  </td-wb-form-row>

  <td-wb-form-row class="td-wb-address__form-row">
    <td-wb-input-group class="td-wb-address__form-input">
      <td-wb-input-group-label class="td-wb-address__label">
        <label [for]="'td-wb-address-city-' + usageId()"
               translate="tdWb.address.CITY"
               class="td-wb-address__label"></label>
      </td-wb-input-group-label>
      <td-wb-input-group-field class="td-wb-address__form-input-field">
        <input [attr.id]="'td-wb-address-city-' + usageId()"
               [(ngModel)]="selectedAddress.cityName"
               (ngModelChange)="onViewModelChange()"
               type="text"
               class="td-wb-address__form-input-field"
               autocomplete="address-level2"
               [name]="'city-' + usageId()"
               maxlength=30
               tdWbInput
               [disabled]="isDisabled()"
               required>
        <td-wb-input-errors errorKeyNamespace="tdWb.address.validationMsges.cityName" />
      </td-wb-input-group-field>
    </td-wb-input-group>

    <td-wb-input-group class="td-wb-address__form-input">
      <td-wb-input-group-label class="td-wb-address__label">
        <span [attr.id]="'td-wb-address-territory-label-' + usageId()"
              translate="tdWb.address.PROVINCE"
              class="td-wb-address__label"></span>
      </td-wb-input-group-label>
      <td-wb-input-group-field class="td-wb-address__form-input-field">
        <!--  Workaround for Angular issue: https://github.com/angular/angular/issues/11757.Due to
              Angular's handling of `name` vs. `attr.name`,we need to use both.
              - `[name]` ensures proper form control binding in Angular.
              - `[attr.name]` ensures the attribute is rendered in the DOM.
              Disabling ESLint rule to prevent linting errors on duplicate attributes. -->
        <!-- eslint-disable @angular-eslint/template/no-duplicate-attributes -->
        <td-wb-dropdown [attr.id]="'td-wb-address-territory-' + usageId()"
                        class="td-wb-address__form-input-field"
                        [placeholder]="'tdWb.address.PROVINCE_PLACEHOLDER' | tdWbTranslate"
                        [(ngModel)]="selectedAddress.territory"
                        (ngModelChange)="onViewModelChange()"
                        [ariaLabel]="'tdWb.address.PROVINCE' | tdWbTranslate"
                        [attr.name]="'province-' + usageId()"
                        [name]="'province-' + usageId()"
                        [disabled]="isDisabled()"
                        tdWbInput
                        required>
          @for (aProvince of getProvinces(); track aProvince[0]) {
            <td-wb-dropdown-item [value]="aProvince[0]">
              <span>{{ aProvince[1] }}</span>
            </td-wb-dropdown-item>
          }
        </td-wb-dropdown>
        <!-- eslint-enable @angular-eslint/template/no-duplicate-attributes -->
        <!-- re-enabling Eslint rule to maintain proper linting for the rest of the file -->
        <td-wb-input-errors errorKeyNamespace="tdWb.address.validationMsges.province" />
      </td-wb-input-group-field>
    </td-wb-input-group>

    <td-wb-input-group class="td-wb-address__form-input-small">
      <td-wb-input-group-label class="td-wb-address__label">
        <label [for]="'td-wb-address-postalcode-' + usageId()"
               translate="tdWb.address.POSTAL_CODE"
               class="td-wb-address__label"></label>
      </td-wb-input-group-label>
      <td-wb-input-group-field class="td-wb-address__form-input-field">
        <input [attr.id]="'td-wb-address-postalcode-' + usageId()"
               [(ngModel)]="selectedAddress.postalCode"
               (ngModelChange)="onViewModelChange()"
               type="text"
               class="td-wb-address__form-input-field"
               autocomplete="postal-code"
               [name]="'postalCode-' + usageId()"
               [tdWbPostalCodeValidator]="selectedAddress.territory"
               maxlength=6
               [disabled]="isDisabled()"
               required
               tdWbInput>
        <td-wb-input-errors errorKeyNamespace="tdWb.address.validationMsges.postalCode" />
      </td-wb-input-group-field>
    </td-wb-input-group>

  </td-wb-form-row>

  @if (showRuralRouteAndPOBox()) {
    <td-wb-form-row class="td-wb-address__form-row">
      @if (usageId() !== 'home') {
        <td-wb-input-group class="td-wb-address__form-input">
          <td-wb-input-group-label class="td-wb-address__label">
            <label [for]="'td-wb-address-po-box-type-' + usageId()"
                   translate="tdWb.address.PO_BOX_TYPES"
                   class="td-wb-address__label"></label>
          </td-wb-input-group-label>
          <td-wb-input-group-field class="td-wb-address__form-input-field">
            <!--  Workaround for Angular issue: https://github.com/angular/angular/issues/11757.Due to
                  Angular's handling of `name` vs. `attr.name`,we need to use both.
                  - `[name]` ensures proper form control binding in Angular.
                  - `[attr.name]` ensures the attribute is rendered in the DOM.
                  Disabling ESLint rule to prevent linting errors on duplicate attributes. -->
            <!-- eslint-disable @angular-eslint/template/no-duplicate-attributes -->
            <td-wb-dropdown [attr.id]="'td-wb-address-po-box-type-' + usageId()"
                            class="td-wb-address__form-input-field"
                            [placeholder]="'tdWb.address.PROVINCE_PLACEHOLDER' | tdWbTranslate"
                            [(ngModel)]="ruralOrPoBoxType"
                            (ngModelChange)="onViewModelChange()"
                            [aria-labelledby]="'td-wb-address-po-box-type-' + usageId()"
                            [attr.name]="'td-wb-address-po-box-type-' + usageId()"
                            [name]="'td-wb-address-po-box-type-' + usageId()"
                            [disabled]="isDisabled()"
                            tdWbInput>
              <td-wb-dropdown-item [value]="undefined">
                <span translate="tdWb.address.PROVINCE_PLACEHOLDER"></span>
              </td-wb-dropdown-item>
              @for (aType of getRuralPoTypes(); track aType) {
                <td-wb-dropdown-item [value]="aType">
                  <span [translate]="'tdWb.address.' + aType"></span>
                </td-wb-dropdown-item>
              }
            </td-wb-dropdown>
            <!-- eslint-enable @angular-eslint/template/no-duplicate-attributes -->
            <!-- re-enabling Eslint rule to maintain proper linting for the rest of the file -->
            <td-wb-input-errors errorKeyNamespace="tdWb.address.validationMsges.province" />
          </td-wb-input-group-field>
        </td-wb-input-group>
      }
      <td-wb-input-group class="td-wb-address__form-input">
        <td-wb-input-group-label class="td-wb-address__label">
          <label [for]="'td-wb-address-pobox-' + usageId()"
                 [translate]="usageId() === 'home' ? 'tdWb.address.RURAL_ROUTE_OPTIONAL': 'tdWb.address.PO_BOX_NUM'"
                 class="td-wb-address__label"></label>
        </td-wb-input-group-label>
        <td-wb-input-group-field class="td-wb-address__form-input-field">
          <input [attr.id]="'td-wb-address-pobox-' + usageId()"
                 [(ngModel)]="ruralOrPoBox"
                 (ngModelChange)="onRuralOrPoB0xChange()"
                 [name]="'ruralRoute-' + usageId()"
                 tdWbInput
                 [tdWbRuralRoutePoBoxInput]="getRuralOrPoBoxType()"
                 type="number"
                 class="td-wb-address__form-input-field"
                 [required]="isPoBoxRuralRouteRequired()"
                 [disabled]="isDisabled() || disablePOBoxRuralRoute()">
          <td-wb-input-errors errorKeyNamespace="tdWb.address.validationMsges.poBoxRuralRoute" />
        </td-wb-input-group-field>
      </td-wb-input-group>
      <td-wb-input-group class="td-wb-address__form-input-small">
        <td-wb-input-group-label class="td-wb-address__label">
          <label [for]="'td-wb-address-station-' + usageId()"
                 translate="tdWb.address.STATION"
                 class="td-wb-address__label"></label>
        </td-wb-input-group-label>
        <td-wb-input-group-field class="td-wb-address__form-input-field">
          <input [attr.id]="'td-wb-address-station-' + usageId()"
                 [(ngModel)]="selectedAddress.postalStationTxt"
                 (ngModelChange)="onViewModelChange()"
                 type="text"
                 class="td-wb-address__form-input-field"
                 [name]="'station-' + usageId()"
                 maxlength=30
                 tdWbInput
                 [disabled]="isDisabled() || shouldDisableStation()">
          <td-wb-input-errors errorKeyNamespace="tdWb.address.validationMsges.postalCode" />
        </td-wb-input-group-field>
      </td-wb-input-group>
    </td-wb-form-row>
  }
</div>
